// @core/api/endpoints/document/resolve_document_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveDocumentContextRequest,
  ResolveDocumentContextResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Resolve document context
 * Resolves the effective document management policy for a scope entity by merging the policy hierarchy. Returns merged policy, available templates, numbering schemes, workflows, and allowed document types.
 */
export async function ResolveDocumentContext(
  data: ResolveDocumentContextRequest,
  options?: RequestOptions
): Promise<ResolveDocumentContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/documents/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveDocumentContextResponse>(requestPath, data, requestOptions);
}
